<template>
    <component
        :is="cardTag"
        :class="classObject"
        :to="to"
        data-spec-class="card"
    >
        <slot name="avatar" />
        <div class="min-w-0 flex-1">
            <slot />
        </div>

        <div
            v-if="$slots.action"
            class="mt-1 sm:mt-0 sm:ml-6 sm:flex sm:shrink-0 sm:items-center"
        >
            <slot name="action" />
        </div>
    </component>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { Theme } from '@/types';
import { RouteLocationNormalized, RouterLink } from 'vue-router';

interface Props {
    tag?: string;
    theme?: Theme;
    to?: RouteLocationNormalized;
}

const props = withDefaults(defineProps<Props>(), {
    tag: 'div',
    theme: Theme.Normal,
    to: undefined,
});

const cardTag = computed(() => {
    if (props.to) {
        return RouterLink;
    }

    return props.tag;
});

const classObject = computed(() => ({
    'relative flex space-x-3 rounded-sm border border-divider px-6 py-5 transition duration-300': true,
    'bg-surface text-primary': props.theme === Theme.Normal,
    'bg-gray-800 dark:bg-gray-800 text-gray-100 dark:text-gray-100': props.theme === Theme.Dark,
    'relative overflow-y-hidden cursor-pointer hover:ring-2 hover:ring-offset-white hover:ring-blue-700 hover:ring-offset-1':
        props.to,
    'dark:hover:ring-blue-700 dark:hover:ring-offset-gray-900': props.to,
}));
</script>
